import { render } from "./UiCheckDirtyBeforeRouteLeave.vue?vue&type=template&id=384c3efb&ts=true"
import script from "./UiCheckDirtyBeforeRouteLeave.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiCheckDirtyBeforeRouteLeave.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UiCheckDirtyBeforeRouteLeave.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "384c3efb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('384c3efb', __exports__)) {
    api.reload('384c3efb', __exports__)
  }
  
  module.hot.accept("./UiCheckDirtyBeforeRouteLeave.vue?vue&type=template&id=384c3efb&ts=true", () => {
    api.rerender('384c3efb', render)
  })

}


export default __exports__